import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-8 sm:mt-32" }
const _hoisted_2 = { class: "mt-4 bg-white w-[40%] min-w-[360px] min-h-[360px] shadow-md border-b-2 border-h-primary-500 rounded-md p-4" }
const _hoisted_3 = { class: "flex flex-row justify-between" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = { class: "flex flex-row justify-between items-center mt-8" }
const _hoisted_6 = { class: "flex flex-row justify-between items-center mt-8" }
const _hoisted_7 = { class: "flex flex-row justify-between items-center mt-8" }
const _hoisted_8 = { class: "flex flex-row gap-4 items-center mt-8" }
const _hoisted_9 = { class: "flex flex-row justify-end gap-4 items-center mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!

  return (_ctx.attentionConfig)
    ? (_openBlock(), _createElementBlock("form", {
        key: 0,
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.saveConfig()), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("labels.generic", {
            pt: "Configurações gerais",
            en: "General settings",
          })), 1),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Monitoramento de atenção",
                en: "Attention monitoring",
              })), 1),
              _createVNode(_component_InputSwitch, {
                modelValue: _ctx.attentionConfig.attentionEnabled,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.attentionConfig.attentionEnabled) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Ao ligar o monitoramento de atenção, nossa IA de reconhecimento facial irá checar se o aluno está atento ao vídeo.",
              en: "When turning attention monitoring on, our facial recognition AI will check if the student is attentive to the video.",
            })), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h6", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Intervalo de detecção (segundos)",
                en: "Detection interval (seconds)",
              })), 1),
              _createVNode(_component_InputNumber, {
                modelValue: _ctx.attentionConfig.detectionInterval,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.attentionConfig.detectionInterval) = $event)),
                inputId: "minmax-buttons",
                mode: "decimal",
                showButtons: "",
                min: 0,
                class: "w-[82px] h-[30px]",
                disabled: !_ctx.attentionConfig.attentionEnabled
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h6", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Ângulo da cabeça (graus)",
                en: "Head angle (degrees)",
              })), 1),
              _createVNode(_component_InputNumber, {
                modelValue: _ctx.attentionConfig.headAngle,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.attentionConfig.headAngle) = $event)),
                inputId: "minmax-buttons",
                mode: "decimal",
                showButtons: "",
                min: 0,
                max: 90,
                class: "w-[82px] h-[30px]",
                disabled: !_ctx.attentionConfig.attentionEnabled
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h6", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Porcentagem de presença (%)",
                en: "Attendance percentage (%)",
              })), 1),
              _createVNode(_component_InputNumber, {
                modelValue: _ctx.attentionConfig.presencePercentage,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.attentionConfig.presencePercentage) = $event)),
                inputId: "minmax-buttons",
                mode: "decimal",
                showButtons: "",
                min: 0,
                max: 100,
                class: "w-[82px] h-[30px]",
                disabled: !_ctx.attentionConfig.attentionEnabled
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.attentionConfig.obligatoryPresence,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.attentionConfig.obligatoryPresence) = $event)),
                binary: true,
                disabled: !_ctx.attentionConfig.attentionEnabled
              }, null, 8, ["modelValue", "disabled"]),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Presença obrigatória ativada",
                en: "Mandatory presence enabled",
              })), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Button, {
                class: "btn-primary h-8",
                type: "submit",
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", {
                pt: "Salvar",
                en: "Save",
              })), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ])
        ])
      ], 32))
    : _createCommentVNode("", true)
}